import AddressUS, { DEFAULT_VALUE } from './AddressUS';

export default AddressUS;
export { DEFAULT_VALUE };